import "core-js/modules/es.array.splice.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "card card-custom gutter-b",
    staticStyle: {
      "box-shadow": "none"
    }
  }, [_c('div', {
    staticClass: "card-header card-header-tabs-line"
  }, [_c('ul', {
    ref: "builder-tab",
    staticClass: "nav nav-dark nav-bold nav-tabs nav-tabs-line",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "data-tab": "0",
      "data-toggle": "tab",
      "href": "#",
      "role": "tab"
    },
    on: {
      "click": _vm.setActiveTab
    }
  }, [_vm._v(" Cadastro ")])]), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-tab": "1",
      "data-toggle": "tab",
      "href": "#",
      "role": "tab"
    },
    on: {
      "click": _vm.setActiveTab
    }
  }, [_vm._v(" Endereços ")])]), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-tab": "2",
      "data-toggle": "tab",
      "href": "#",
      "role": "tab"
    },
    on: {
      "click": _vm.setActiveTab
    }
  }, [_vm._v(" E-mail ")])]), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-tab": "3",
      "data-toggle": "tab",
      "href": "#",
      "role": "tab"
    },
    on: {
      "click": _vm.setActiveTab
    }
  }, [_vm._v(" Telefones ")])])])]), _c('div', {
    staticClass: "card-body"
  }, [_c('b-tabs', {
    staticClass: "hide-tabs",
    model: {
      value: _vm.tabIndex,
      callback: function callback($$v) {
        _vm.tabIndex = $$v;
      },
      expression: "tabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "active": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "nome",
      "label-for": "responsavel",
      "label": "Nome do contador"
    }
  }, [_c('b-form-input', {
    attrs: {
      "state": _vm.validateState('nome'),
      "autofocus": ""
    },
    model: {
      value: _vm.$v.form.nome.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.nome, "$model", $$v);
      },
      expression: "$v.form.nome.$model"
    }
  })], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "crc",
      "label": "CRC",
      "label-for": "crc"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "crc",
      "name": "crc",
      "maxLength": "15",
      "state": _vm.validateState('crc')
    },
    model: {
      value: _vm.form.crc,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "crc", $$v);
      },
      expression: "form.crc"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "cpf",
      "label": "CPF do contador",
      "label-for": "cpf"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ['###.###.###-##'],
      expression: "['###.###.###-##']"
    }],
    attrs: {
      "id": "cpf",
      "name": "cpf",
      "state": _vm.validateState('cpf')
    },
    model: {
      value: _vm.form.cpf,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cpf", $$v);
      },
      expression: "form.cpf"
    }
  })], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "cnpj_cpf",
      "label": "CNPJ da contabilidade",
      "label-for": "cnpj_cpf"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "cnpj_cpf",
      "name": "cnpj_cpf"
    },
    nativeOn: {
      "input": function input($event) {
        return _vm.onCpfCnpjInput($event, _vm.form, 'cnpj_cpf');
      }
    },
    model: {
      value: _vm.form.cnpj_cpf,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cnpj_cpf", $$v);
      },
      expression: "form.cnpj_cpf"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _c('b-tab', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Tipo",
      "label-for": "tipo_endereco"
    }
  }, [_c('b-form-select', {
    attrs: {
      "placeholder": "",
      "state": _vm.validateStateEndereco('tipo')
    },
    model: {
      value: _vm.$v.formEndereco.tipo.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.formEndereco.tipo, "$model", $$v);
      },
      expression: "$v.formEndereco.tipo.$model"
    }
  }, _vm._l(_vm.tipoEndereco, function (t, index) {
    return _c('b-form-select-option', {
      key: 'tipo_endereco' + index,
      attrs: {
        "value": t
      }
    }, [_vm._v(" " + _vm._s(t.descricao) + " ")]);
  }), 1)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "CEP",
      "label-for": "formEndereco.cep"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ['#####-###'],
      expression: "['#####-###']"
    }],
    ref: "cep",
    attrs: {
      "id": "formEndereco.cep",
      "name": "formEndereco.cep",
      "state": _vm.validateStateEndereco('cep'),
      "aria-describedby": "formEndereco.cep"
    },
    model: {
      value: _vm.$v.formEndereco.cep.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.formEndereco.cep, "$model", $$v);
      },
      expression: "$v.formEndereco.cep.$model"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('a', {
    staticClass: "btn btn-primary font-weight-bold",
    on: {
      "click": _vm.consultaCep
    }
  }, [_vm._v(" Consultar CEP ")])])], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Número",
      "label-for": "formEndereco.numero"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "formEndereco.numero",
      "name": "formEndereco.numero",
      "aria-describedby": "formEndereco.numero"
    },
    model: {
      value: _vm.formEndereco.numero,
      callback: function callback($$v) {
        _vm.$set(_vm.formEndereco, "numero", $$v);
      },
      expression: "formEndereco.numero"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Bairro",
      "label-for": "formEndereco.bairro"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "formEndereco.bairro",
      "name": "formEndereco.bairro",
      "aria-describedby": "formEndereco.bairro"
    },
    model: {
      value: _vm.formEndereco.bairro,
      callback: function callback($$v) {
        _vm.$set(_vm.formEndereco, "bairro", $$v);
      },
      expression: "formEndereco.bairro"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Logradouro",
      "label-for": "formEndereco.logradouro"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "formEndereco.logradouro",
      "name": "formEndereco.logradouro",
      "aria-describedby": "formEndereco.logradouro"
    },
    model: {
      value: _vm.formEndereco.logradouro,
      callback: function callback($$v) {
        _vm.$set(_vm.formEndereco, "logradouro", $$v);
      },
      expression: "formEndereco.logradouro"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Complemento",
      "label-for": "formEndereco.complemento"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "formEndereco.complemento",
      "name": "formEndereco.complemento",
      "aria-describedby": "formEndereco.complemento"
    },
    model: {
      value: _vm.formEndereco.complemento,
      callback: function callback($$v) {
        _vm.$set(_vm.formEndereco, "complemento", $$v);
      },
      expression: "formEndereco.complemento"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Cidade",
      "label-for": "formEndereco.cidade"
    }
  }, [_c('VueSelect', {
    attrs: {
      "label": "cidade",
      "options": _vm.cidades
    },
    on: {
      "input": _vm.setCidade,
      "search": _vm.onSearch
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.cidade + " - " + option.uf) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.cidade + " - " + option.uf) + " ")])];
      }
    }])
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o nome da cidade ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "1"
    }
  }, [_c('button', {
    staticClass: "btn btn-light-primary btn-bold",
    staticStyle: {
      "margin-top": "25px",
      "margin-right": "15px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onSubmitEndereco
    }
  }, [_vm._v(" Adicionar ")])])], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "11"
    }
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Tipo")]), _c('th', [_vm._v("CEP")]), _c('th', [_vm._v("Logradouro")]), _c('th', [_vm._v("Bairro")]), _c('th', [_vm._v("Número")]), _c('th', [_vm._v("Complemento")]), _c('th', [_vm._v("Cidade")]), _c('th')])]), _c('tbody', _vm._l(_vm.enderecos, function (e, index) {
    return _c('tr', {
      key: 'endereco_' + index
    }, [e.id_tipo == 1 ? _c('td', [_vm._v("Principal")]) : _vm._e(), _c('td', [_vm._v(_vm._s(e.cep))]), _c('td', [_vm._v(_vm._s(e.logradouro))]), _c('td', [_vm._v(_vm._s(e.bairro))]), _c('td', [_vm._v(_vm._s(e.numero))]), _c('td', [_vm._v(_vm._s(e.complemento))]), _c('td', [_vm._v(" " + _vm._s(e.cidade == null ? "" : e.cidade.cidade + " - " + e.cidade.uf) + " ")]), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_c('button', {
      staticClass: "btn btn-light-primary btn-sm btn-bold",
      on: {
        "click": function click() {
          _vm.$toast.error('Endereço excluído');
          _vm.enderecos.splice(index, 1);
        }
      }
    }, [_c('Close', {
      attrs: {
        "size": 16
      }
    })], 1)])]);
  }), 0)])])], 1)], 1), _c('b-tab', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Tipo",
      "label-for": "tipo_email"
    }
  }, [_c('b-form-select', {
    attrs: {
      "placeholder": "",
      "state": _vm.validateStateEmail('tipo')
    },
    model: {
      value: _vm.$v.formEmail.tipo.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.formEmail.tipo, "$model", $$v);
      },
      expression: "$v.formEmail.tipo.$model"
    }
  }, _vm._l(_vm.tipoEmail, function (t, index) {
    return _c('b-form-select-option', {
      key: 'tipo_email' + index,
      attrs: {
        "value": t
      }
    }, [_vm._v(" " + _vm._s(t.descricao) + " ")]);
  }), 1)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "7"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "email",
      "label": "E-mail",
      "label-for": "formEmail.email"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "formEmail.email",
      "name": "formEmail.email",
      "state": _vm.validateStateEmail('email'),
      "aria-describedby": "formEmail.email"
    },
    model: {
      value: _vm.$v.formEmail.email.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.formEmail.email, "$model", $$v);
      },
      expression: "$v.formEmail.email.$model"
    }
  })], 1)], 1), _c('b-col', [_c('button', {
    staticClass: "btn btn-light-primary btn-bold",
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onSubmitEmail
    }
  }, [_vm._v(" Adicionar ")])])], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "10"
    }
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Tipo")]), _c('th', [_vm._v("E-mail")]), _c('th')])]), _c('tbody', _vm._l(_vm.emails, function (e, index) {
    var _e$tipo;
    return _c('tr', {
      key: 'email_' + index
    }, [_c('td', [_vm._v(_vm._s((_e$tipo = e.tipo) === null || _e$tipo === void 0 ? void 0 : _e$tipo.descricao))]), _c('td', [_vm._v(" " + _vm._s(e.email) + " ")]), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_c('button', {
      staticClass: "btn btn-light-primary btn-sm btn-bold",
      on: {
        "click": function click() {
          _vm.$toast.error('E-mail excluído');
          _vm.emails.splice(index, 1);
        }
      }
    }, [_c('Close', {
      attrs: {
        "size": 16
      }
    })], 1)])]);
  }), 0)])])], 1)], 1), _c('b-tab', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Tipo",
      "label-for": "tipo_telefone"
    }
  }, [_c('b-form-select', {
    attrs: {
      "placeholder": "",
      "state": _vm.validateStateTelefone('tipo')
    },
    model: {
      value: _vm.$v.formTelefone.tipo.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.formTelefone.tipo, "$model", $$v);
      },
      expression: "$v.formTelefone.tipo.$model"
    }
  }, _vm._l(_vm.tipoFone, function (t, index) {
    return _c('b-form-select-option', {
      key: 'tipo_telefone' + index,
      attrs: {
        "value": t
      }
    }, [_vm._v(" " + _vm._s(t.descricao) + " ")]);
  }), 1)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "7"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "telefone",
      "label": "Telefone",
      "label-for": "example-input-0"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ['(##) #### ####', '(##) # #### ####'],
      expression: "['(##) #### ####', '(##) # #### ####']"
    }],
    attrs: {
      "state": _vm.validateStateTelefone('telefone'),
      "aria-describedby": "input-0-live-feedback"
    },
    model: {
      value: _vm.$v.formTelefone.telefone.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.formTelefone.telefone, "$model", $$v);
      },
      expression: "$v.formTelefone.telefone.$model"
    }
  })], 1)], 1), _c('b-col', [_c('button', {
    staticClass: "btn btn-light-primary btn-bold",
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onSubmitTelefone
    }
  }, [_vm._v(" Adicionar ")])])], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "10"
    }
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Tipo")]), _c('th', [_vm._v("Telefone")]), _c('th')])]), _c('tbody', _vm._l(_vm.telefones, function (e, index) {
    var _e$tipo2;
    return _c('tr', {
      key: 'fone_' + index
    }, [_c('td', [_vm._v(_vm._s((_e$tipo2 = e.tipo) === null || _e$tipo2 === void 0 ? void 0 : _e$tipo2.descricao))]), _c('td', [_vm._v(" " + _vm._s(e.fone) + " ")]), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_c('button', {
      staticClass: "btn btn-light-primary btn-sm btn-bold",
      on: {
        "click": function click() {
          _vm.$toast.error('Telefone excluído');
          _vm.telefones.splice(index, 1);
        }
      }
    }, [_c('Close', {
      attrs: {
        "size": 16
      }
    })], 1)])]);
  }), 0)])])], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    ref: "submit_nova_pessoa",
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(" Salvar ")]), _c('router-link', {
    staticClass: "btn btn-clean font-weight-bold",
    attrs: {
      "to": {
        name: 'contadorLista'
      }
    }
  }, [_vm._v(" Cancelar ")])], 1)])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };